<div class="sales-filter-bar" [class.client-filters]="role === 'client'">
  <mat-card class="mt-0">
    <mat-card-content class="p-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between mx-1">
        <form
        #filtersFormDirective="ngForm"
        [formGroup]="filtersFormGroup"
        class="mt-2 flex-fill d-flex flex-wrap justify-content-between"
        [class]="role === 'client' ? 'w-75' : 'w-100'"
        (submit)="filterListItems()">
          <mat-form-field class="ms-1 pb-2" [ngClass]="{ 'w-100': role === 'client' }">
            <mat-label>{{ 'SALES.PUBLISHED_DATE' | translate }}
              <!-- workaround for material-chrome bug -->
							<select id="createdDate" style="display: none"></select>
            </mat-label>

            <mat-date-range-input [rangePicker]="picker" color="primary" [max]="DATE_RANGE_LIMITS.dateTo">
							<input id="createdAtFrom" formControlName="createdAtFrom" matStartDate />
							<input id="createdAtTo" formControlName="createdAtTo" matEndDate />
						</mat-date-range-input>
						<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker>
							<mat-date-range-picker-actions>
								<button mat-button matDateRangePickerCancel>{{ 'BUTTON.CANCEL' | translate }}</button>
								<button mat-raised-button color="primary" matDateRangePickerApply (click)="INSTANT_SEARCH ? filterListItems() : null">{{ 'BUTTON.APPLY' | translate }}</button>
							</mat-date-range-picker-actions>
						</mat-date-range-picker>

          </mat-form-field>

          <mat-form-field class="ms-1 pb-2 flex-fill" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label>{{ 'SALES.TRUSTEE' | translate }}</mat-label>
						<input type="text" matInput formControlName="trusteeIds" [matAutocomplete]="trusteeAutocomplete" />
						<mat-autocomplete #trusteeAutocomplete [displayWith]="displayFn.bind(this)">
							@for(filteredItem of filteredTrustees; track $index) {
							<mat-option [value]="filteredItem">
								{{ utils.getParameterByLanguageScript(filteredItem, 'name', true) }}
							</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>

          <mat-form-field class="ms-1 pb-2 flex-fill me-auto" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label>{{ 'SALES.DEBTOR' | translate }}</mat-label>
						<input type="text" matInput formControlName="debtorIds" [matAutocomplete]="debtorAutocomplete" />
						<mat-autocomplete #debtorAutocomplete [displayWith]="displayFn.bind(this)">
							@for(filteredItem of filteredDebtors; track $index) {
							<mat-option [value]="filteredItem">
								{{ utils.getParameterByLanguageScript(filteredItem, 'name', true) }}
							</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>

          <mat-form-field class="ms-1 pb-2 flex-fill me-auto" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label>{{ 'SALES.LOCATION' | translate }} / {{ 'SALES.PLACE_OF_SALE' | translate}}</mat-label>
						<input type="text" matInput formControlName="location" [matAutocomplete]="locationAutocomplete" />
						<mat-autocomplete #locationAutocomplete>
							@for(filteredItem of filteredLocations; track $index) {
							<mat-option [value]="filteredItem">
								{{ filteredItem }}
							</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>

					<mat-form-field class="ms-1 pb-2" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label>{{ 'SALES.TYPE' | translate }}</mat-label>
						<select id="saleTypes" style="display: none"></select>
						<mat-select id="saleTypesSelect" formControlName="types" multiple>
							<mat-option #selectAllSaleTypes value="ALL" (click)="saleTypeSelection()">{{ 'SALES.TYPES.ALL' | translate }}</mat-option>
							@for (saleType of saleTypes; track $index) {
							<mat-option [value]="saleType" (click)="saleTypeSelection($event)">{{ 'SALES.TYPES.' + saleType | translate }}</mat-option>
							}
						</mat-select>
					</mat-form-field>

          <div class="ms-1 d-flex justify-content-end mb-1">
						<button
							type="button"
							mat-raised-button
							color="primary"
							class="me-1"
							aria-label="Reset form button"
							matTooltip="{{ 'CLIPS.RESET_FORM' | translate }}"
							matTooltipPosition="below"
							(click)="resetForm(filtersFormDirective)">
							<mat-icon class="m-0">restart_alt</mat-icon>
						</button>

						@if (!INSTANT_SEARCH) {
						<button type="submit" mat-raised-button class="me-1" aria-label="Filter button" [disabled]="apiLoading">
							@if(apiLoading) {
							<mat-spinner diameter="20"></mat-spinner>
							} @else {
							<span>{{ 'BUTTON.SHOW' | translate }}</span>
							}
						</button>
						}
            </div>
        </form>
      </div>
      <mat-divider class="w-100"></mat-divider>
    </mat-card-content>
  </mat-card>
</div>
